import { QuoteEmail } from "./email.model";
import { BaseQuote } from "./quote-base.model";
import { Rate } from "../../rate/rate-type";
import { Location } from "../../location/location.model";
import { Client } from "../../client/client.model";
import { BaseUser } from "../../user/base-user.model";
import { FclTier } from "../../tier/tier-fcl.model";
import { ContainerName } from "../../shared/container/container-name.type.const";

export class FclTariff extends BaseQuote {
  constructor(
    protected id: number,
    protected displayId: string,
    protected groupId: number,
    protected ref: string,
    protected sender: BaseUser,
    protected createdBy: BaseUser,
    protected status: string,
    protected quoteType: string,
    protected direction: string,
    protected clients: Client[],
    protected originLocations: Location[],
    protected destinationLocations: Location[],
    protected equipment: ContainerName[],
    protected createdAt: Date,
    protected updatedAt: Date,
    protected updatedBy: BaseUser,
    protected openedAt: Date,
    protected validFrom: Date,
    protected validTo: Date,
    protected comment: string,
    protected email: QuoteEmail,
    protected internalComment: string,
    protected customTerms: string,
    protected rates: Rate[],
    protected tier: FclTier,
    protected showRateSurcharges: boolean,
    protected showInternalNotes: boolean,
    protected showExternalNotes: boolean,
    protected showRateName: boolean,
    protected showAllLocationsInOneSheet: boolean,
    protected fileName: string,
    protected fileNameInternal: string,
    protected averageMargin: number,
    protected inquiry: string,
    protected source: string,
    protected reasonOfDecline: string,
    protected input: string | null,
  ) {
    super(
      id,
      displayId,
      groupId,
      ref,
      sender,
      createdBy,
      status,
      quoteType,
      clients,
      createdAt,
      updatedAt,
      updatedBy,
      openedAt,
      validFrom,
      validTo,
      email,
      internalComment,
      customTerms,
      fileName,
      fileNameInternal,
      averageMargin,
      inquiry,
      source,
      null,
      reasonOfDecline,
      input,
    );
  }

  public getDirection(): string {
    return this.direction;
  }

  public setDirection(direction: string): void {
    this.direction = direction;
  }

  public getOriginLocations(): Location[] {
    return this.originLocations;
  }

  public setOriginLocations(locations: Location[]): void {
    this.originLocations = locations;
  }

  public getDestinationLocations(): Location[] {
    return this.destinationLocations;
  }
  public setDestinationLocations(locations: Location[]): void {
    this.destinationLocations = locations;
  }

  public getEquipment(): ContainerName[] {
    return this.equipment;
  }
  public setEquipment(eq: ContainerName[]): void {
    this.equipment = eq;
  }

  public getRates(): Rate[] {
    return this.rates;
  }
  public setRates(param: Rate[]): void {
    this.rates = param;
  }

  public getTier(): FclTier {
    return this.tier;
  }
  public setTier(param: FclTier): void {
    this.tier = param;
  }

  public getComment(): string {
    return this.comment;
  }

  public setShowRateSurcharges(showRateSurcharges: boolean) {
    this.showRateSurcharges = showRateSurcharges;
  }
  public getShowRateSurcharges(): boolean {
    return this.showRateSurcharges;
  }

  public setComment(comment: string) {
    this.comment = comment;
  }

  public getShowInternalNotes(): boolean {
    return this.showInternalNotes;
  }
  public setShowInternalNotes(param: boolean) {
    this.showInternalNotes = param;
  }

  public getShowExternalNotes(): boolean {
    return this.showExternalNotes;
  }
  public setShowExternalNotes(param: boolean) {
    this.showExternalNotes = param;
  }

  public getShowRateName(): boolean {
    return this.showRateName;
  }
  public setShowRateName(param: boolean) {
    this.showRateName = param;
  }

  public getShowAllLocationsInOneSheet(): boolean {
    return this.showAllLocationsInOneSheet;
  }
  public setShowAllLocationsInOneSheet(param: boolean) {
    this.showAllLocationsInOneSheet = param;
  }

  public isValid() {
    return super.isValid();
  }

  public isSendable(): boolean {
    return super.isSendable() && this.getRates() && this.getRates().length > 0;
  }
}
